import { useState, useEffect, FormEvent } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, MODAL_SIZES } from 'ui/modal';
import { PrimaryButton } from 'ui/button';
import { FormField } from 'ui/formField';
import { RadioGroup } from 'ui/radioGroup/radioGroup';
import { SANDBOX, NORMAL } from '../constants';

type ProjectEditModalProps = {
  /** Bool to show or hide the modal */
  open: boolean;
  /** Function that closes the modal */
  closeModal: () => void;
  /** Function to call when submit is clicked */
  handleAction: (project: Record<string, any>) => void;
  /** Object that holds the form data for project */
  project: Record<string, any>;
};

export const EditModal = ({
  closeModal,
  handleAction,
  open = false,
  project = {},
}: ProjectEditModalProps) => {
  const [projectType, setProjectType] = useState<'Sandbox' | 'Normal'>(SANDBOX);

  useEffect(() => {
    setProjectType(project.isSandbox ? SANDBOX : NORMAL);
  }, [project]);

  const projectTypeRadioButtonOptions = [
    { value: NORMAL, dataTest: NORMAL, label: NORMAL, id: NORMAL },
    { value: SANDBOX, dataTest: SANDBOX, label: SANDBOX, id: SANDBOX },
  ];

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    handleAction({
      ...project,
      isSandbox: projectType === SANDBOX,
    });
    closeModal();
  };

  return open ? (
    <Modal
      id="projectsEditModal"
      onClose={closeModal}
      isModalOpen={open}
      data-test="EditModal"
      size={MODAL_SIZES.SMALL}
    >
      <ModalHeader>
        Edit {project.name} (ID: {project.id}, Org ID: {project.organizationId})
      </ModalHeader>
      <ModalBody>
        <form id="editProjectForm" onSubmit={onSubmit}>
          <FormField labelText="Project type" inputId="projectType">
            <RadioGroup
              name="projectType"
              onSelect={setProjectType}
              value={projectType}
              options={projectTypeRadioButtonOptions}
            />
          </FormField>
        </form>
      </ModalBody>
      <ModalFooter onClose={closeModal}>
        <PrimaryButton type="submit" data-test="EditModal-Submit" form="editProjectForm">
          Save changes
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  ) : null;
};

export default EditModal;
